module.exports = __webpack_public_path__ + "img/qr.c37ad9ad.svg";